import apiHttpRequest from "services/api-http-request";
import chungohhhh1HttpRequest from "services/chungohhhh1-http-request";
import moment from 'moment';
import { sortBy, groupBy } from 'lodash';

const processHourlyData = (data) => {

  const groupByHourData = groupBy(data, (d) => (moment(d.timestamp).format('YYYY-MM-DD HH:00:00')));

  let processedData = [];

  for (const [key, value] of Object.entries(groupByHourData)) {
    
    const entries = value;

    const time = key;
    let highest = 0;
    let lowest = null;
    let sum = 0;
    let count = 0;
    let average = 0;

    entries.forEach((entry) => {
      
      const sensorValue = entry.sensor_value;
      
      highest = Math.max(highest, sensorValue);
      if (lowest === null) {
        lowest = sensorValue;
      } else {
        lowest = Math.min(lowest, sensorValue);
      }
      sum += sensorValue;
      count++
    });

    if (count > 0) {
      average = Math.round(sum/count*100)/100;
    }

    processedData.push({
      time,
      highest,
      lowest,
      sum,
      count,
      average
    });
  }

  processedData = sortBy(processedData, 'time');

  return processedData;
}

const processChartInputData = (data, chartDisplayType, labelsFormat) => {
  const hourlyData = processHourlyData(data);

  let labels = [];
  let highestData = [];
  let lowestData = [];
  let averageData = [];

  if (hourlyData) {
    labels = hourlyData.map((d) => moment(d.time).format(labelsFormat || 'HH'));
    highestData = hourlyData.map((d) => d.highest);
    lowestData = hourlyData.map((d) => d.lowest);
    averageData = hourlyData.map((d) => d.average);
  }

  const newChartInputData = { labels };

  if (chartDisplayType === 'all' || chartDisplayType === 'average') {
    newChartInputData.data1 = {
      name: '평균',
      color: '#AEE3E5',
      data: averageData
    }
  }

  if (chartDisplayType === 'all' || chartDisplayType === 'highest') {
    newChartInputData.data2 = {
      name: '최고',
      color: '#FFD3C6',
      data: highestData
    }
  }

  if (chartDisplayType === 'all' || chartDisplayType === 'lowest') {
    newChartInputData.data3 = {
      name: '최저',
      color: '#DBFFD5',
      data: lowestData
    }
  }

  return newChartInputData;
}

const processTableInputData = (data) => {
  const hourlyData = processHourlyData(data);

  const groupByDateData = groupBy(hourlyData, (d) => (moment(d.time).format('YYYY-MM-DD')));

  let processedData = [];

  for (const [key, value] of Object.entries(groupByDateData)) {
    const entries = value;

    const date = key;
    let hourlyData = entries.map((val) => ({
      hour: moment(val.time).format('HH:00'),
      value: val.average
    }));
    hourlyData = sortBy(hourlyData, 'hour')
    
    processedData.push({
      date,
      hourlyData
    });
  }

  processedData = sortBy(processedData, 'date');

  return processedData;
}

const getSensorUnit = (sensorType) => {
  let unit = '';

  if (sensorType) {
    if (sensorType.toUpperCase().startsWith('TEMP_')) {
      unit = '°C';
    } else if (sensorType.toUpperCase().startsWith('RH_')) {
      unit = '%';
    } else if (sensorType.toUpperCase().startsWith('WIND_')) {
      unit = '°';
    } else if (sensorType.toUpperCase().startsWith('WINDSPEED_')) {
      unit = 'm/s';
    } else if (sensorType.toUpperCase().startsWith('SOLAR_')) {
      unit = 'W/㎡';
    } else if (sensorType.toUpperCase().startsWith('FAN_')) {
      unit = 'm/s';
    }
  }

  return unit;
}

const getChartOverrideOptions = (sensorType) => {
  let overrideOptions = null;

  if (sensorType) {
    if (sensorType.toUpperCase().startsWith('TEMP_') || sensorType.toUpperCase().startsWith('SOILTEMP_') || sensorType.toUpperCase().startsWith('WATERTEMP_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 50,
            min: -50,
            ticks: {
              stepSize: 10
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('RH_') || sensorType.toUpperCase().startsWith('SOILRH_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 150,
            ticks: {
              stepSize: 50
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('WIND_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 400,
            ticks: {
              stepSize: 200
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('WINDSPEED_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 15,
            ticks: {
              stepSize: 5
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('CO2_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 1000,
            ticks: {
              stepSize: 500
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('EC_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 100,
            ticks: {
              stepSize: 50
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('PH_')) {
      overrideOptions = {
        scales: {
          y: {
            max: 10,
            ticks: {
              stepSize: 5
            }
          }
        }
      }
    } else if (sensorType.toUpperCase().startsWith('SOLAR_')) {
      overrideOptions = null;
    }
  }

  return overrideOptions;
}

const getDashboadData = async (val, startDate, endDate) => {
  const params = {};
  let kmaSensorType = '';
  let outSensorType = '';
  let kisangcheong = {};
  let outdoor = {};

  

  if (startDate && startDate.length > 0) {
    params.start_time = startDate
  }

  if (endDate && endDate.length > 0) {
    params.end_time = endDate;
  }

  if(val === '1'){
    outSensorType = 'TEMP_OUTDOOR_1';      // 온도
    kmaSensorType = 'TMP';
  }else if(val === '2'){
    outSensorType = 'RH_OUTDOOR_1';        // 습도
    kmaSensorType = 'REH';
  }else if(val === '3'){
    outSensorType = 'WIND_OUTDOOR_1';      // 풍향
    kmaSensorType = 'VEC';
  }else if(val === '4'){
    outSensorType = 'WINDSPEED_OUTDOOR_1'; // 풍속
    kmaSensorType = 'WSD';
  }
    console.log('서비스 kma'+kmaSensorType)
  try {
    outdoor = await apiHttpRequest.get(`/outdoor/weather_station/${outSensorType}`, params);
    console.log('outdoorAPI response', outdoor)
    
    kisangcheong = await apiHttpRequest.get(`/outdoor/weather_korea/${kmaSensorType}`, params);
    console.log('kisangcheongAPI response', kisangcheong)
    

  } catch (e) {
    console.error(e);
  }

  // 두 데이터 병합 후 차트 데이터로 변환
  const outData = dashboadChartInputData(outdoor, 'out', val);
  const kmaData = dashboadChartInputData(kisangcheong, 'kma', val);

  // const detail = {
  //   labels: outData.labels, // 또는 kmaData.labels (둘이 동일해야 함)
  //   data1: {
  //     name: kmaData.data2.name,
  //     data: kmaData.data2.data,
  //   },
  //   data2: {
  //     name: outData.data1.name,
  //     data: outData.data1.data,
  //   },
  // };

   // labels를 통합하는 함수 추가
   const intersectLabels = (labels1, labels2) => 
    labels1.filter((label) => labels2.includes(label));
  
  const getDataByUnifiedLabels = (data, labels, unifiedLabels) => {
    // unifiedLabels에 맞는 데이터를 추출
    const labelIndexMap = labels.reduce((map, label, index) => {
      map[label] = index;
      return map;
    }, {});
  
    return unifiedLabels.map((label) => {
      const index = labelIndexMap[label];
      return index !== undefined ? data[index] : null;
    });
  };
  
  // labels를 통합하는 작업을 detail 객체를 정의하기 전에 수행
  const unifiedLabels = intersectLabels(outData.labels, kmaData.labels);
  
  const detail = {
    labels: unifiedLabels,
    data1: {
      name: kmaData.data2.name,
      data: getDataByUnifiedLabels(kmaData.data2.data, kmaData.labels, unifiedLabels),
    },
    data2: {
      name: outData.data1.name,
      data: getDataByUnifiedLabels(outData.data1.data, outData.labels, unifiedLabels),
    },
  };

  return detail
}


const dashboadChartInputData = (data, chartDisplayType, val) => {
  const hourlyData = processHourlyData(data);

  let labels = [];
  let averageData = [];

  if (hourlyData) {
    labels = hourlyData.map((d) => moment(d.time).format('HH'));

    averageData = hourlyData.map((d) => d.average);
  }
  const newChartInputData = { labels, processedData: hourlyData };
   // val 값에 따라 name 설정
   const getNameByVal = (val) => {
    switch (val) {
      case '1':
        return '평균 온도';
      case '2':
        return '평균 습도';
      case '3':
        return '평균 풍향';
      case '4':
        return '평균 풍속';
      default:
        return '데이터 없음';
    }
  };

  if (chartDisplayType === 'out') {
    newChartInputData.data1 = {
      name: `외부 ${getNameByVal(val)}`,
      color: '#AEE3E5',
      data: averageData,
    };
  }

  if (chartDisplayType === 'kma') {
    newChartInputData.data2 = {
      name: `기상청 ${getNameByVal(val)}`,
      color: '#FFD3C6',
      data: averageData,
    };
  }
  // if (chartDisplayType === 'out') {
  //   newChartInputData.data1 = {
  //     name: '외부 기상 온도',
  //     color: '#AEE3E5',
  //     data: averageData
  //   }
  // }

  // if (chartDisplayType === 'kma') {
  //   newChartInputData.data2 = {
  //     name: '기상청 관측 온도',
  //     color: '#FFD3C6',
  //     data: averageData
  //   }
  // }

  return newChartInputData;
}



export default {
  processHourlyData,
  processChartInputData,
  processTableInputData,
  getSensorUnit,
  getChartOverrideOptions,
  getDashboadData
}